import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import packageJson from "../../package.json";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const fetchAllCity = createAsyncThunk(
  'book/fetchTrips',
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const res = await axios.get(`${BaseUrl}/cities`, {       headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, });
      const result = await res.data.data;
      return result;
    } catch (error) {
       if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      return rejectWithValue(error.message);
    }
  }
);



const CitySlice = createSlice({
  name: 'City',
  initialState: { Cities: [], loading: false, error: null },
  reducers: {
    clearCity: (state) => {
      state.Cities = [];
      state.loading = false;
      state.error = null;

    },
  },
  extraReducers: {
    //fetch
    [fetchAllCity.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [fetchAllCity.fulfilled]: (state, action) => {
      state.Cities = action.payload;
      state.loading = false;
    },
    [fetchAllCity.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});
export const { clearCity } = CitySlice.actions;
export default CitySlice.reducer;
